// Acquisition attribution (20.8.2026, "close the measurement hole").
// captureAttribution(): call once on app start — if the landing URL carries
// utm_* params (or an fbclid, which only Facebook adds), store them in
// localStorage. First touch wins: a later visit never overwrites.
// flushAttribution(): call once the user is signed in — writes the stored
// source onto their profile via the claim_attribution RPC (which itself
// keeps only the first value), then clears the local copy.

import { supabase } from "./supabase";

const KEY = "acq_utm_v1";

export function captureAttribution(): void {
  try {
    const p = new URLSearchParams(window.location.search);
    let source = p.get("utm_source") || (p.get("fbclid") ? "facebook" : null);
    let medium = p.get("utm_medium") || "";
    // No tags? Fall back to the referrer host — the 23.8 audit found every
    // sign-up of the week arriving through untagged doors (profile link,
    // WhatsApp, old posts, search). "direct" when there is no referrer.
    if (!source) {
      const ref = document.referrer ? new URL(document.referrer).hostname : "";
      if (ref && ref.endsWith(window.location.hostname)) return; // internal nav
      source = /facebook|fb\.com|fbcdn/.test(ref) ? "facebook"
        : /instagram/.test(ref) ? "instagram"
        : /whatsapp/.test(ref) ? "whatsapp"
        : /google/.test(ref) ? "google"
        : ref ? ref.replace(/^www\./, "") : "direct";
      medium = "referral";
    }
    // First touch wins — except a bare "direct", which a later real source
    // (ad, referral) is allowed to replace.
    const prev = window.localStorage.getItem(KEY);
    if (prev && (JSON.parse(prev).source !== "direct" || source === "direct")) return;
    window.localStorage.setItem(
      KEY,
      JSON.stringify({
        source,
        medium,
        campaign: p.get("utm_campaign") || "",
        landed_at: new Date().toISOString(),
      })
    );
  } catch {
    /* storage unavailable (private mode) — attribution is best-effort */
  }
}

export async function flushAttribution(): Promise<void> {
  try {
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return;
    const a = JSON.parse(raw);
    const { error } = await supabase.rpc("claim_attribution", {
      _source: a.source,
      _medium: a.medium || null,
      _campaign: a.campaign || null,
      _landed_at: a.landed_at || null,
    });
    if (!error) window.localStorage.removeItem(KEY);
  } catch {
    /* best-effort — never block the app on attribution */
  }
}
